// extracted by mini-css-extract-plugin
export var button = "accordion-module--button--b44cd";
export var buttonActive = "accordion-module--button-active--347e8";
export var content = "accordion-module--content--ac201";
export var icon = "accordion-module--icon--2b7e6";
export var title = "accordion-module--title--1ee8e";
export var wrapper = "accordion-module--wrapper--31982";